import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const FoundOnStarHome = ({ onAuthorize }) => {
  const { i18n } = useTranslation();

  return (
    <div>
      <div className='subheading'>{i18n.t('mig.scope.ONSTAR_HOME.title')}</div>
      <p>{i18n.t('mig.onstar.general.label')}</p>

      <div className='subheading'>{i18n.t('mig.alexa.title.label')}</div>
      <p>{i18n.t('mig.alexa.general.label')}</p>

      <button
        id='authorize-btn'
        style={{ marginTop: '2em', marginBottom: '1em' }}
        className='square-button'
        onClick={onAuthorize}
      >
        {i18n.t('papi.general.authorize.lable')}
      </button>
    </div>
  );
};

FoundOnStarHome.propTypes = {
  onAuthorize: PropTypes.func,
};

export default FoundOnStarHome;
